import React from 'react'
import MuiCheckbox from '@mui/material/Checkbox'
import { useField } from 'formik'

export const CheckBox = ({ ...props }) => {
    const [field] = useField(props.name)

    return <MuiCheckbox {...field} style={{ color: '#00835E' }} checked={field.value} />
}

export const CustomCheckBox = ({ value, checked, index, item, onChange, filterType }) => {
    return (
        <div className="inner">
            <input
                key={index}
                type="checkbox"
                name={item}
                id={item + filterType}
                value={item}
                checked={checked}
                onChange={onChange}
                tabIndex="0"
                aria-label={item}
                data-filter-type={filterType}
            />
            <label htmlFor={item + filterType} id={`checkbox ${filterType}`}>
                <svg viewBox="0 0 100 100">
                    <path
                        className="box"
                        d="M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"
                    />
                    <polyline className="check" points="25.5,53.5 39.5,67.5 72.5,34.5 " />
                </svg>
                <span>{value}</span>
            </label>
        </div>
    )
}
